export default "__VITE_ASSET__BiBOegux__"